import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Form } from '../components';

Form.propTypes = {
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
};

export default HyperdbForm(Form, {
  namespace: 'propertyGroup',
  mountedUrl: '/propertyGroups',
  titleNew: 'Create new group',
  titleEdit: 'Edit group',
  displayName: (object) => object.name,
  checkIsValid: (props) => !!props.objectData.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/containers/Form.jsx